import React from 'react'

import { User } from './User'
import { useUserInfo } from '../../../store/user'
import { useIsEditingUser, useSocketServerState } from '../../../store/socketServer'
import { useUserRole } from '../../../store/user/hooks/useUserRole'

export const CurrentUser: React.FC = () => {
  const user = useUserInfo()
  const userRole = useUserRole()
  const isEditingUser = useIsEditingUser()
  const socketServer = useSocketServerState()

  if (!user.name) {
    return null
  }

  return (
    <User
      isFirst={false}
      isLast
      id={user.id}
      name={user.name}
      role={userRole}
      picture={user.picture}
      connected={socketServer.roomState ? socketServer.isConnected : undefined}
      isEditing={isEditingUser}
      email={user.email}
    />
  )
}
